import React from 'react';

interface IProps {
  height: number;
}

const Spacer = ({ height }: IProps): JSX.Element => <div style={{ height }} />;

export default Spacer;
